export default __webpack_public_path__ + "static/1_27-7a3c85bb2b3895d1793fe991053f0bb9.png";